import {register} from '../vendor/theme-scripts/theme-sections';
import productGridReviews from '../features/product-grid';
import {quickviewSection} from '../features/quickview';
import gridSlider from '../features/grid-slider';

register('product-grid', [productGridReviews, gridSlider, quickviewSection]);
